import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-b" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex items-center justify-between h-20" }
const _hoisted_4 = {
  style: {"background-color":"#F7FAFF"},
  class: "h-28 w-40', 'absolute top-0 left-0 text-center border border-gray-300 border-t-0 border-radius-5 shadow"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "hidden md:block" }
const _hoisted_7 = { class: "ml-4 flex items-center md:ml-6" }
const _hoisted_8 = { class: "hidden md:block" }
const _hoisted_9 = { class: "ml-10 flex items-baseline space-x-4" }
const _hoisted_10 = { class: "border-l border-dashed border-gray-400 pl-5" }
const _hoisted_11 = { class: "relative z-10 flex items-center lg:hidden" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open menu", -1)
const _hoisted_13 = { class: "border-t pt-2 pb-3 px-2 space-y-1" }
const _hoisted_14 = { class: "w-full border-t" }
const _hoisted_15 = { class: "w-full border-t" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Bars3Icon = _resolveComponent("Bars3Icon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_Disclosure, {
      as: "header",
      class: "bg-white shadow"
    }, {
      default: _withCtx(({ open: menuIsOpen }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "relative h-20 w-40"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "h-28 w-32 inline",
                    src: `/${_ctx.appId}/logo-full.svg`,
                    alt: "Ammo Exchange"
                  }, null, 8, _hoisted_5)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openRegister && _ctx.openRegister(...args))),
                        class: "text-gray-800 px-3 py-2 text-sm font-medium cursor-pointer"
                      }, "Become a Member"),
                      _createElementVNode("a", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openLogin && _ctx.openLogin(...args))),
                        class: "text-gray-800 px-3 py-2 text-sm font-medium cursor-pointer"
                      }, "Login")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_DisclosureButton, { class: "rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  (!menuIsOpen)
                    ? (_openBlock(), _createBlock(_component_Bars3Icon, {
                        key: 0,
                        class: "block h-6 w-6",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(_component_XMarkIcon, {
                        key: 1,
                        class: "block h-6 w-6",
                        "aria-hidden": "true"
                      }))
                ]),
                _: 2
              }, 1024)
            ])
          ])
        ]),
        _createVNode(_component_DisclosurePanel, {
          as: "nav",
          class: "md:hidden",
          "aria-label": "Global"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_DisclosureButton, {
                onClick: _ctx.openLogin,
                class: "w-full text-right text-gray-900 hover:bg-gray-50 hover:text-gray-900 block rounded-md py-2 px-3 text-base font-medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Login ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_DisclosureButton, {
                  onClick: _ctx.openRegister,
                  class: "w-full text-right text-gray-900 hover:bg-gray-50 hover:text-gray-900 block rounded-md py-2 px-3 text-base font-medium"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Become a Member ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_router_link, {
                  to: "/how-it-works",
                  class: "w-full text-right text-gray-900 hover:bg-gray-50 hover:text-gray-900 block rounded-md py-2 px-3 text-base font-medium"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" How It Works ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}